<script setup>
    import { breadcrumbsFromURL } from '@/composables/helpers/urls'

    const route = useRoute()
    const breadcrumbs = ref(breadcrumbsFromURL(route.path))
    const params = { url: btoa(route.path) }

    useSchemaOrg([ defineBreadcrumb({ itemListElement: breadcrumbs.value }) ])

    const { status, data } = await useLazyAsyncData('breadcrumbs', () => $fetch('/api/breadcrumbs', { params: params }), { server: false })

    const removeTrailingSlashes = (str) => {
        return str.replace(/\/+$/, '');
    }

    watch(data, () => {
        breadcrumbs.value = data.value.map(item => ({
            name: item.title,
            item: item.url
        }))
    })

</script>
<template>
	<div class="breadcrumbs-wrapper" v-if="breadcrumbs && breadcrumbs.length > 1">
		<div class="container">
			<ul class="breadcrumbs fs-12" :class="breadcrumbs.length >= 2 ? 'mobile-chop' : null">
				<li v-for="(item, index) in breadcrumbs">
					<MessLink v-if="item.name && item.item && removeTrailingSlashes(item.item) != removeTrailingSlashes(route.path)" :href="item.item" class="base">
						<span v-html="item.name" tag="span" />
					</MessLink>
					<span v-else class="active">
						<span v-html="item.name" tag="span" />
					</span>
					<span class="pipe" v-if="index < breadcrumbs.length - 1">></span>
				</li>
			</ul>
		</div>
	</div>
</template>

<style lang="scss">
	.breadcrumbs-wrapper {
		position: absolute;
		top: var(--header-height);
		left: 50%;
		transform: translateX(-50%);

		background: var(--gray-100);
		padding: 1.5rem 0;
		width: 100%;
		z-index: 1;

		.container {
			.breadcrumbs {
				display: flex;
				align-items: center;
				padding: 0;
				margin: 0;
				list-style: none;
				gap: 1rem;

				li {
                    display: flex;
                    align-items: center;
					color: #000;
					font-size: 10px;
					font-style: normal;
					font-weight: 800;
					line-height: 100%; /* 12.31px */
					letter-spacing: 1.15px;
					text-transform: uppercase;

                    span {
                        display: inline-block;
                        max-width: 15vw;
                        overflow-x: hidden;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        @media (max-width: $mobile) {
                            max-width: 25vw;
                        }
                    }

                    * {
						color: #000;
						font-size: 10px;
						font-style: normal;
						font-weight: 800;
						line-height: 123.1%; /* 12.31px */
						letter-spacing: 1.15px;
						text-transform: uppercase;
						transition: 250ms ease-in-out;

						&.mess-link {
							border-bottom: 1px solid;

							&:hover {
								color: var(--gray-600);
							}
						}
					}

					.pipe {
						margin-left: 1rem;
						border-bottom: 0;
						&:hover {
							color: var(--black);
						}
					}
				}
			}
		}

		@media (max-width: $mobile) {
			.container {
				.breadcrumbs {
					&.mobile-chop {
						li:nth-of-type(n + 2) {
							display: none;
						}
						li:nth-of-type(1),
						li:nth-last-of-type(1) {
							display: block;
						}
					}
				}
			}
		}
	}
</style>
